import React from "react";
import {
  KTMScreen,
  ActionEvent,
  RenderEvent,
  renderScreen,
  TabSet,
  Tab,
  RecordHeader,
} from "ktm-ui";
import { KTMApi } from "api/KTMApi";
import { Layout, Display, Line, Column, Panel, Button, Card } from "ktm-ui";
import Dependent_listScreen from "./Dependent_list";
import Date_range_listScreen from "./Date_range_list";
import EditScreen from "./Edit";
import TerminateScreen from "./Terminate";
import Edit_addressScreen from "./Edit_address";
import Edit_bencatScreen from "./Edit_bencat";
import CustomToolTip from "../../components/CustomToolTip";
import axios from "axios";
import BenefitEditScreen from "../employee_benefits/Edit";
import moment from "moment";
import { Modal } from "react-bootstrap";
import ReactButton from "react-bootstrap/Button";
import ReactMoment from "react-moment";
import BenefitEditFlexDatesScreen from "../employee_benefits/Edit_flex_dates";
import toastr from "toastr";
import CustomDisplayElement from "components/CustomDisplayElement";
import BenefitEditBenefitDatesScreen from "../employee_benefits/Edit_benefit_dates";
import BenefitEditEmployeeStartDateScreen from "../employee_benefits/Edit_employee_start_date";
import "../../styles/Ops.css";

interface IdsEmployee {
  Id: string;
  FirstName: string;
  LastName: string;
  Name: string;
  Email: string;
  MaidenName: string;
  Nickname: string;
  EmployeeNo: string;
  DateOfBirth: string;
  HireDate: string;
  TerminationDate: string;
  TerminationNote: string;
  BenefitStartDate: string;
  Division_Id: string;
  CostCentre_Id: string;
  WaitingPeriodMonths: number;
  MailingStreet1: string;
  MailingStreet2: string;
  MailingCity: string;
  MailingProv: string;
  MailingCountry: string;
  MailingPostalCode: string;
  HomePhone: string;
  MobilePhone: string;
  BenefitCategory_Id: string;
  AccessAfterTerminationDays: number;
  IsActive: boolean;
  SalaryMoney: number;
}

interface IdsPolicies {
  Id: string;
  CurrentBenYear_Id: string;
  IsBusinessOwner: boolean;
}

interface IdsPolicyHolder {
  Id: string;
  Name: string;
}

interface IdsPolicyBenefit {
  EffectiveDate: string;
  CarryFwdHSA: string;
  CarryFwdLSA: string;
}

interface IdsPolicyBenefitYear {
  Id: string;
  StartDate: string;
  EndDate: string;
}

interface IdsDivision {
  Id: string;
  Name: string;
  Description: string;
  FullName: string;
}

interface IdsCostCentre {
  Id: string;
  Name: string;
  Description: string;
  FullName: string;
}

interface IdsBenefitCategory {
  Id: string;
  Policy_Id: string;
  Name: string;
  Description: string;
}

interface IdsEmployeeYear {
  Id: string;
  BenefitYear_Id: string;
  FlexLaunchDate: string;
  FlexReminderDate: string;
  FlexLastDayReminderDate: string;
  FlexSelectionDeadline: string;
  FlexBase: number;
  IsFlexSelectionDefault: boolean;
  IsFlexSelectionDone: boolean;
  FlexChoiceMade: string;
  HSABalance: number;
  LSABalance: number;
  HSABase: number;
  LSABase: number;
  HSACarriedIn: number;
  LSACarriedIn: number;
  HSAMaxCarryFwd: number;
  LSAMaxCarryFwd: number;
}

interface IdsPreviousEmployeeBenefits {
  Id: string;
  BenefitYear_Id: string;
  BenefitName: string;
  BenefitHasHSA: boolean;
  BenefitHasLSA: boolean;
  BenefitCategoryName: string;
  Status: string;
  Coverage: string;
  HasProrating: boolean;
  HSABase: number;
  LSABase: number;
  HSALimitOverride: number;
  LSALimitOverride: number;
  HSAProrated: number;
  LSAProrated: number;
  FlexProrated: number;
  RSPChoiceAmount: number;
  FlexBase: number;
  HasHSA: boolean;
  HasLSA: boolean;
  HasFlex: boolean;
  HasRSP: boolean;
}

interface IdsPlanAdmins {
  Id: string;
  UserId: string;
}

export default KTMScreen(
  { name: "planadmin.employee.record" },
  class extends React.Component<{ employee_id: string }> {
    data: {
      dsEmployee: IdsEmployee;
      dsDivision: IdsDivision;
      dsCostCentre: IdsCostCentre;
      dsBenefitCategory: IdsBenefitCategory;
      dsEmployeeYear: IdsEmployeeYear;
      dsPreviousEmployeeBenefits: IdsPreviousEmployeeBenefits;
      dsPolicies: IdsPolicies;
      dsPolicyBenefit: IdsPolicyBenefit;
      dsPolicyHolder:IdsPolicyHolder;
      dsPolicyBenefitYear: IdsPolicyBenefitYear;
      dsPlanAdmins: IdsPlanAdmins;
    };

    state = {
      terminationLog: [],
      showTerminationDeleteModal: false,
      enableBenefitEdit: false,
      showReinstateModal: false,
      reinstateNote: "",
      hasHsa: false,
      hasLsa: false,
      hsaAdjustment: null,
      lsaAdjustment: null,
      prevYearHasHsa: false,
      prevYearHasLsa: false,
      prevYearHSAAdjustment: null,
      prevYearLSAAdjustment: null,
      showDateRangeModal: false,
      isStartDateValid: false,
      isAllowBenefitCategoryEdit: false,
      employeeCustomCategories: null,
      employeePrevCustomCategories: null
    };

    render() {
      return renderScreen(this);
    }

    componentDidMount() {
      this.getTerminationLog();
      this.getAdjustments();
      this.getPreviousYearAdjustments();
      this.getEmployeeCustomCategories();
      this.getEmployeePrevCustomCategories();
    }

    async start({ screen }: ActionEvent) {
      screen.defaultRecord = "@dsEmployee";
      await KTMApi.start(screen, {
        "@employee_id": this.props.employee_id,
      });
      screen.title =
        screen.getValue("FirstName") + " " + screen.getValue("LastName");

      this.checkFirstYearCoverage();
      this.checkIsAllowBenefitCategoryEdit();
      this.checkEmployeeStartDate();
      this.getEmployeeCustomCategories();
      this.getEmployeePrevCustomCategories();
    }

    getTerminationLog = () => {
      fetch("/api/Terminate?id=" + this.props.employee_id, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            terminationLog: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    };

    getAdjustments = () => {
      fetch(
        "/api/employees/getadjustingentry?employeeId=" + this.props.employee_id,
        {
          method: "GET",
        }
      )
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            hasHsa: data.hasHsa,
            hasLsa: data.hasLsa,
            hsaAdjustment: data.hsaAdjustment,
            lsaAdjustment: data.lsaAdjustment,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    };

    getPreviousYearAdjustments = () => {
      fetch(
        "/api/employees/getpreviousyearadjustingentry?employeeId=" + this.props.employee_id,
        {
          method: "GET",
        }
      )
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            prevYearHasHsa: data.prevYearHasHsa,
            prevYearHasLsa: data.prevYearHasLsa,
            prevYearHSAAdjustment: data.prevYearHSAAdjustment,
            prevYearLSAAdjustment: data.prevYearLSAAdjustment,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    };

    getEmployeeCustomCategories = () => {
      fetch(
        "/api/employees/getemployeecustomcategories?employeeId=" + this.props.employee_id,
        {
          method: "GET",
        }
      )
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            employeeCustomCategories: data.employeeCustomCategories,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }

    getEmployeePrevCustomCategories = () => {
      fetch(
        "/api/employees/getemployeeprevcustomcategories?employeeId=" + this.props.employee_id,
        {
          method: "GET",
        }
      )
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            employeePrevCustomCategories: data.employeePrevCustomCategories,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }

    showTerminationDeleteModal = () => {
      this.setState({ showTerminationDeleteModal: true });
    };

    closeTerminationDeleteModal = () => {
      this.setState({ showTerminationDeleteModal: false });
    };

    main({ field, draw, action }: RenderEvent) {
      return (
        <Layout>
          {draw(this.header)}
          {draw(this.tabset)}
        </Layout>
      );
    }

    header({ field, draw, action, getValue }: RenderEvent) {

      return (
        <RecordHeader
          entityLabel="Employee"
          label={getValue("Name")}
        >
          <Line>
            <Display field={field("Email")} textStyle="bold" />
            <Display
              field={field("@dsBenefitCategory.Name")}
              textStyle="bold"
            />
            <Display field={field("DateOfBirth")} />
            <Display field={field("HireDate")} />
          </Line>
        </RecordHeader>
      );
    }

    tabset({ field, draw, action }: RenderEvent) {
      return (
        <TabSet>
          <Tab label="Details" template={this.main_tab} />
          <Tab label="Dependents" template={this.dependents} />
          <Tab label="Benefit Limits" template={this.benefits} />
          <Tab label="Date Ranges" template={this.date_ranges} />
          <Tab label="Terminations" template={this.terminations} />
        </TabSet>
      );
    }

    terminations({ field, draw, action }: RenderEvent) {
      return (
        <Panel>
          <Column>
            {draw(this.termination_details)}
            {draw(this.termination_status)}
          </Column>
        </Panel>
      );
    }
    
    main_tab({ field, draw, action }: RenderEvent) {
      return (
        <Panel>
          <Column>
            {draw(this.general)}
            {draw(this.contact_info)}
            {draw(this.reporting)}
          </Column>
        </Panel>
      );
    }

    dependents({ field, draw, action }: RenderEvent) {
      return <Dependent_listScreen employee_id={this.data.dsEmployee.Id} />;
    }

    date_ranges({ field, draw, action }: RenderEvent) {
      return <Date_range_listScreen employee_id={this.data.dsEmployee.Id} />;
    }

    benefits({ field, draw, action }: RenderEvent) {
      var limits = <Line>No Limits to Display</Line>;
      var systemBenefitStartDate = this.systemGeneratedBenefitStartDate();

      let hsaLimitBreakdown = null;
      if(this.data.dsEmployeeYear.HSACarriedIn > 0 && this.data.dsEmployeeYear.HSABase > 0)
      {
        hsaLimitBreakdown = (
            <label style={{ paddingBottom: 15 }}>
                ${this.data.dsEmployeeYear.HSABase} = ${this.data.dsEmployeeYear.HSAMaxCarryFwd} (Benefit Category) + ${this.data.dsEmployeeYear.HSACarriedIn} (Carried In)
            </label>
        );
      }

      let lsaLimitBreakdown = null;
      if(this.data.dsEmployeeYear.LSACarriedIn > 0 && this.data.dsEmployeeYear.LSABase > 0)
      {
        lsaLimitBreakdown = (
            <label style={{ paddingBottom: 15 }}>
                ${this.data.dsEmployeeYear.LSABase} = ${this.data.dsEmployeeYear.LSAMaxCarryFwd} (Benefit Category) + ${this.data.dsEmployeeYear.LSACarriedIn} (Carried In)
            </label>
        );
      }

      let rspLimit = null;
      if(field("@dsPolicyBenefitLimits.HasRsp").record.HasRsp === true)
      {
        rspLimit = (
          <Line>
              <Display field={field("@dsEmployeeYear.RSPChoiceAmount")} />
              <Display field={field("@dsPolicyBenefitLimits.HasRsp")} />
          </Line>
        )
      }

      if (field("@dsEmployeeYear.HasProrating").record.HasProrating === true) {
        let HSAProratedLimit = null;
        if(field("@dsPolicyBenefitLimits.HasHSA").record.HasHSA === true)
        {
          HSAProratedLimit = (
              <Line>
                <Display field={field("@dsEmployeeYear.HSAProrated")} />
                <Display field={field("@dsPolicyBenefitLimits.HasHSA")} />
              </Line>
          )
        }

        let LSAProratedLimit = null;
        if(field("@dsPolicyBenefitLimits.HasLSA").record.HasLSA === true)
        {
          LSAProratedLimit = (
              <Line>
                <Display field={field("@dsEmployeeYear.LSAProrated")} />
                <Display field={field("@dsPolicyBenefitLimits.HasLSA")} />
              </Line>
          )
        }
        
        limits = (
          <Card>
            {HSAProratedLimit}
            {LSAProratedLimit}
            {rspLimit}
          </Card>
        );
      } else {
        if (field("@dsEmployeeYear.Coverage").record.Coverage == "FAMILY") {
          let hsaFamilyLimit = null;
          if (field("@dsPolicyBenefitLimits.HasHSA").record.HasHSA === true) {
            if(field("@dsEmployeeYear.HSALimitOverride").record.HSALimitOverride == 0)
            {
              hsaFamilyLimit = (
                <Line>
                  <Display field={field("@dsEmployeeYear.HSABase")} />
                  <Display field={field("@dsPolicyBenefit.HasHSA")} />
                </Line>
              );
            } else {
              hsaFamilyLimit = (
                <>
                <Line>
                  <Display
                      field={field("@dsEmployeeYear.HSABase")}
                  />
                    <div className="RT-Static-Field">
                      <label className="RT-Static-Field__label">
                        Has HSA Limit Adjustment
                      </label>
                      <div className="RT-Static-Field__content">
                        {this.state.hsaAdjustment.hasAdjustment ? (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {this.renderStaticCheckmark()}
                            <div>Yes</div>
                          </div>
                        ) : (
                          <span>No</span>
                        )}
                      </div>
                    </div>
                  </Line>
                </>
              );
            }
          }
          
          let lsaFamilyLimit = null;
          if (field("@dsPolicyBenefitLimits.HasLSA").record.HasLSA === true) {
            if(field("@dsEmployeeYear.LSALimitOverride").record.LSALimitOverride == 0)
            {
              lsaFamilyLimit = (
                <Line>
                  <Display field={field("@dsEmployeeYear.LSABase")} />
                  <Display field={field("@dsPolicyBenefit.HasLSA")} />
                </Line>
              );
            } else {
              lsaFamilyLimit = (
                <>
                  <Line>
                    <Display
                        field={field("@dsEmployeeYear.LSABase")}
                    />
                    <div className="RT-Static-Field">
                        <label className="RT-Static-Field__label">
                          Has LSA Limit Adjustment
                        </label>
                        <div className="RT-Static-Field__content">
                          {this.state.lsaAdjustment.hasAdjustment ? (
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {this.renderStaticCheckmark()}
                              <div>Yes</div>
                            </div>
                          ) : (
                            <span>No</span>
                          )}
                        </div>
                      </div>
                  </Line>
                </>
              );
            }
          }

          limits = (
            <Card>
              {hsaFamilyLimit}
              {hsaLimitBreakdown}
              {lsaFamilyLimit}
              {lsaLimitBreakdown}
              {rspLimit}
            </Card>
          );
        } else if (field("@dsEmployeeYear.Coverage").record.Coverage == "SINGLE") {
          let hsaLimit = null;
          if (field("@dsPolicyBenefitLimits.HasHSA").record.HasHSA === true) {
            if(field("@dsEmployeeYear.HSALimitOverride").record.HSALimitOverride == 0)
            {
              hsaLimit = (
                <Line>
                  <Display field={field("@dsEmployeeYear.HSABase")} />
                  <Display field={field("@dsPolicyBenefitLimits.HasHSA")} />
                </Line>
              );
            } else {
              hsaLimit = (
                <>
                <Line>
                  <Display
                      field={field("@dsEmployeeYear.HSABase")}
                  />
                    <div className="RT-Static-Field">
                      <label className="RT-Static-Field__label">
                        Has HSA Limit Adjustment
                      </label>
                      <div className="RT-Static-Field__content">
                        {this.state.hsaAdjustment.hasAdjustment ? (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {this.renderStaticCheckmark()}
                            <div>Yes</div>
                          </div>
                        ) : (
                          <span>No</span>
                        )}
                      </div>
                    </div>
                  </Line>
                </>
              );
            }
          }
          
          let lsaLimit = null;
          if (field("@dsPolicyBenefitLimits.HasLSA").record.HasLSA === true) {
            if(field("@dsEmployeeYear.LSALimitOverride").record.LSALimitOverride == 0)
            {
              lsaLimit = (
                <Line>
                  <Display field={field("@dsEmployeeYear.LSABase")} />
                  <Display field={field("@dsPolicyBenefitLimits.HasLSA")} />
                </Line>
              );
            } else {
              lsaLimit = (
                <>
                <Line>
                  <Display
                    field={field("@dsEmployeeYear.LSABase")}
                  />
                  <div className="RT-Static-Field">
                    <label className="RT-Static-Field__label">
                      Has LSA Limit Adjustment
                    </label>
                    <div className="RT-Static-Field__content">
                      {this.state.lsaAdjustment.hasAdjustment ? (
                        <div
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          {this.renderStaticCheckmark()}
                          <div>Yes</div>
                        </div>
                      ) : (
                        <span>No</span>
                      )}
                    </div>
                  </div>
                </Line>
              </>
          );
            }
          }

          limits = (
            <Card>
              {hsaLimit}
              {hsaLimitBreakdown}
              {lsaLimit}
              {lsaLimitBreakdown}
              {rspLimit}
            </Card>
          );
        } else if (field("@dsEmployeeYear.Coverage").record.Coverage == "COUPLE") {
          let hsaCoupleLimit = null;
          if (field("@dsPolicyBenefitLimits.HasHSA").record.HasHSA === true) {
            if(field("@dsEmployeeYear.HSALimitOverride").record.HSALimitOverride == 0)
            {
              hsaCoupleLimit = (
                <Line>
                  <Display field={field("@dsEmployeeYear.HSABase")} />
                  <Display field={field("@dsPolicyBenefit.HasHSA")} />
                </Line>
              );
            } else {
              hsaCoupleLimit = (
                <>
                <Line>
                  <Display
                      field={field("@dsEmployeeYear.HSABase")}
                  />
                    <div className="RT-Static-Field">
                      <label className="RT-Static-Field__label">
                        Has HSA Limit Adjustment
                      </label>
                      <div className="RT-Static-Field__content">
                        {this.state.hsaAdjustment.hasAdjustment ? (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {this.renderStaticCheckmark()}
                            <div>Yes</div>
                          </div>
                        ) : (
                          <span>No</span>
                        )}
                      </div>
                    </div>
                  </Line>
                </>
              );
            }
          }
          
          let lsaCoupleLimit = null;
          if (field("@dsPolicyBenefitLimits.HasLSA").record.HasLSA === true) {
            if(field("@dsEmployeeYear.LSALimitOverride").record.LSALimitOverride == 0)
            {
              lsaCoupleLimit = (
                <Line>
                  <Display field={field("@dsEmployeeYear.LSABase")} />
                  <Display field={field("@dsPolicyBenefit.HasLSA")} />
                </Line>
              );
            } else {
              lsaCoupleLimit = (
                <>
                <Line>
                  <Display
                      field={field("@dsEmployeeYear.LSABase")}
                  />
                    <div className="RT-Static-Field">
                      <label className="RT-Static-Field__label">
                        Has LSA Limit Adjustment
                      </label>
                      <div className="RT-Static-Field__content">
                        {this.state.lsaAdjustment.hasAdjustment ? (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {this.renderStaticCheckmark()}
                            <div>Yes</div>
                          </div>
                        ) : (
                          <span>No</span>
                        )}
                      </div>
                    </div>
                </Line>
                </>
              );
            }
          }
          
          limits = (
            <Card>
              {hsaCoupleLimit}
              {hsaLimitBreakdown}
              {lsaCoupleLimit}
              {lsaLimitBreakdown}
              {rspLimit}
            </Card>
          );
        }
      }
      
      let flexTotal = null;
      let notificationDates = null;
      let flexSelection = null;
      let isEligibleToResendFlex = false;
      if(field("@dsPolicyBenefitLimits.HasFlex").record.HasFlex === true)
      {
        let calcFormula = null;
        if(field("@dsPolicyBenefitLimits.CreditCalcMethod").record.CreditCalcMethod === "SALARY")
        {
          let bencatPercent = null;
          if(field("@dsEmployeeYear.Coverage").record.Coverage == "SINGLE")
          {
            bencatPercent = field("@dsPolicyBenefitLimits.FlexSinglePercent").record.FlexSinglePercent;
          } else if(field("@dsEmployeeYear.Coverage").record.Coverage == "COUPLE")
          {
            bencatPercent = field("@dsPolicyBenefitLimits.FlexCouplePercent").record.FlexCouplePercent;
          } else if(field("@dsEmployeeYear.Coverage").record.Coverage == "FAMILY")
          {
            bencatPercent = field("@dsPolicyBenefitLimits.FlexFamilyPercent").record.FlexFamilyPercent;
          }
  
          let proratedMonthsPart = '';

          if (field("@dsEmployeeYear.HasProrating").record.HasProrating === true) {
              let proratedMonths = this.computeProratedMonths(this.data.dsPolicyBenefitYear.StartDate,
                  this.data.dsPolicyBenefitYear.EndDate,
                  this.data.dsPolicyBenefit.EffectiveDate,
                  this.data.dsEmployee.HireDate, 
                  this.data.dsEmployee.WaitingPeriodMonths);

              proratedMonthsPart = `X ${proratedMonths}/12 (Prorated Months)`;
          }

          calcFormula = (
              <label style={{ paddingBottom: 15 }}>
                  ${field("@dsEmployeeYear.FlexBase").record.FlexBase} = ${field("@dsEmployee.SalaryMoney").record.SalaryMoney} (Salary) X {bencatPercent}% (Benefit Category) {proratedMonthsPart}
              </label>
          );
        }

        flexTotal = (
          <Card>
            <Line>
              <Display field={field("@dsEmployeeYear.FlexBase")} />
              <Display field={field("@dsPolicyBenefitLimits.CreditCalcMethod")} />
            </Line>
            {calcFormula}
          </Card>
        );

        let hasPassedDeadline = moment().isAfter(moment(this.data.dsEmployeeYear.FlexSelectionDeadline).add(1, "day"));
        let hasPassedLaunchDate = moment().isAfter(moment(this.data.dsEmployeeYear.FlexLaunchDate));
        isEligibleToResendFlex = !hasPassedDeadline && hasPassedLaunchDate;

        if(this.state.isStartDateValid)
        {
          notificationDates = (
            <>
              <Card
                label="Notification Dates"
                actions={
                  (this.state.isAllowBenefitCategoryEdit && (!this.data.dsEmployeeYear.IsFlexSelectionDone || !hasPassedDeadline)) &&
                  <>
                    <Button
                      action={action(this.edit_flex_dates)}
                      label="Edit"
                      style="link"
                    />
                  </>
                }
              >
                <Line>
                  <Display field={field("@dsEmployeeYear.FlexLaunchDate")} />
                  <Display field={field("@dsEmployeeYear.FlexReminderDate")} />
                </Line>
                <Line>
                  <Display field={field("@dsEmployeeYear.FlexLastDayReminderDate")} />
                  <Display field={field("@dsEmployeeYear.FlexSelectionDeadline")} />
                </Line>
              </Card>
              {isEligibleToResendFlex && (
                <button
                  onClick={this.resendFlexEmail}
                  className="RT-Button RT-Button--primary"
                  style={{ marginTop: "1rem"}}
                >
                  Resend Flex Email
                </button>
              )}
            </>
          );
        }

        if(this.data.dsEmployeeYear.IsFlexSelectionDone === true)
        {
          let allocatedDateUtc = moment.utc(this.data.dsEmployeeYear.FlexChoiceMade);
          let allocatedDate = moment(allocatedDateUtc).local();
          flexSelection = (
            <Card>
              <Line>
                <div className="RT-Static-Field">
                  <label className="RT-Static-Field__label">
                    Flex Selection
                  </label>
                  <div className="RT-Static-Field__content">
                    {this.data.dsEmployeeYear.IsFlexSelectionDefault ? 
                      "Default" : "Allocated"
                    }
                  </div>
                </div>
                <div className="RT-Static-Field">
                  <label className="RT-Static-Field__label">
                    Flex Last Activity
                  </label>
                  <div className="RT-Static-Field__content">
                    {allocatedDate.format("YYYY-MM-DD hh:mm A")}
                  </div>
                </div>
              </Line>
            </Card>
          );
        }
      }

      const {dsEmployee, dsEmployeeYear, dsPolicies, dsPolicyBenefit, dsPolicyBenefitYear} = this.data;
      var isEligibleToResendWelcomeEmail = dsEmployee.IsActive && 
                        dsEmployee.BenefitStartDate &&
                        moment(dsEmployee.BenefitStartDate).isSameOrBefore(moment()) && 
                        dsPolicyBenefitYear.StartDate && 
                        moment(dsPolicyBenefitYear.StartDate).isSameOrBefore(moment()) &&
                        dsPolicyBenefit.EffectiveDate &&
                        moment(dsPolicyBenefit.EffectiveDate).isSameOrBefore(moment()) &&
                        !dsPolicies.IsBusinessOwner && 
                        (dsEmployeeYear.HSABalance > 0 || dsEmployeeYear.LSABalance > 0 || this.state.employeeCustomCategories?.length > 0);

      let resendWelcomeBtnStyle = isEligibleToResendFlex ? { marginTop: "1rem", marginLeft: "20px"} : { marginTop: "1rem" };

      let balance = null;
      if(field("@dsPolicyBenefitLimits.HasHSA").record.HasHSA === true && field("@dsPolicyBenefitLimits.HasLSA").record.HasLSA === true)
      {
        balance = (
          <Card>
            <Line>
              <Display field={field("@dsEmployeeYear.HSABalance")} />
              <Display field={field("@dsEmployeeYear.LSABalance")} />
            </Line>
          </Card>
        );
      }

      if(field("@dsPolicyBenefitLimits.HasHSA").record.HasHSA === true && field("@dsPolicyBenefitLimits.HasLSA").record.HasLSA === false)
      {
        balance = (
          <Card>
            <Line>
              <Display field={field("@dsEmployeeYear.HSABalance")} />
            </Line>
          </Card>
        );
      }

      if(field("@dsPolicyBenefitLimits.HasHSA").record.HasHSA === false && field("@dsPolicyBenefitLimits.HasLSA").record.HasLSA === true)
      {
        balance = (
          <Card>
            <Line>
              <Display field={field("@dsEmployeeYear.LSABalance")} />
            </Line>
          </Card>
        );
      }

      const dateRangeModal = (
        <Modal 
          show={this.state.showDateRangeModal} 
          onHide={() => this.setState({ showDateRangeModal: false })}
          style={{top:150}}
          centered
        >
          <Modal.Header>
            <Modal.Title style={{fontSize:"17px"}}>Employee Date Range</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              There is an open ended inactive date for this employee. Please update the "Date Ranges" section.
            </div>
          </Modal.Body>
          <Modal.Footer>
            <ReactButton variant="secondary" onClick={() => this.setState({ showDateRangeModal: false })}>
              Close
            </ReactButton>
          </Modal.Footer>
        </Modal>
      );

      let isPlanAdmin = false;
      if(this.data.dsPlanAdmins.UserId 
        && this.data.dsEmployeeYear.HSABase === 0 
        && this.data.dsEmployeeYear.LSABase === 0 
        && this.data.dsEmployeeYear.FlexBase === 0)
      {
        isPlanAdmin = true;
        limits = null;
        balance = null;
      }

      return (
        <>
          {dateRangeModal}
          <Card
            label="Benefit Date Setup"
            actions={
              <>
                {this.state.isAllowBenefitCategoryEdit && (
                  <Button
                    action={action(this.edit_benefitDates)}
                    label="Edit"
                    style="link"
                  />
                )}
              </>
            }
          >
            <Line>
              <Display field={field("HireDate")} />
              <Display
                field={field("WaitingPeriodMonths")}
                toolTip={
                  <CustomToolTip
                    header="Waiting Period (months)"
                    bodyContent="Choose how long an employee waits after being hired for their benefits to start. "
                  />
                }
              />
              <Display field={field("@dsEmployeeYear.HasProrating")} />
            </Line>
          </Card>
          <Card
            label="Employee Start Date"
            actions={
              <>
                {this.state.isAllowBenefitCategoryEdit && (
                  <Button
                    action={action(this.edit_startDate)}
                    label="Edit"
                    style="link"
                  />
                )}
              </>
            }
          >
            <Line>
              <div className="RT-Static-Field">
                <div className="RT-Static-Field__label">
                  <label>System Calculated Benefit Start Date (YYYY-MM-DD)</label>
                </div>
                <div className="RT-Static-Field__content">
                  {systemBenefitStartDate}
                </div>
              </div>
              <Display
                label="PA Approved Benefit Start Date (YYYY-MM-DD)"
                field={field("@dsEmployee.BenefitStartDate")}
              />
              <Display field={field("@dsEmployee.IsStartDateAdjusted")} />
            </Line>
          </Card>
          <Card
            label="Category"
            actions={
              <>
                {this.state.isAllowBenefitCategoryEdit && (
                  <Button
                    action={action(this.edit_benefits)}
                    label="Edit"
                    style="link"
                  />
                )}
              </>
            }
          >
            <Line>
              <Display field={field("@dsPolicyBenefit.Name")} />
            </Line>
            <Line>
              <Display field={field("@dsBenefitCategory.Name")} />
              {isPlanAdmin ? <></> : <Display field={field("@dsEmployeeYear.Coverage")} />}
            </Line>
            {field("@dsPolicyBenefitLimits.CreditCalcMethod").record.CreditCalcMethod === "SALARY" && (
              <Line>
                <Display field={field("@dsEmployee.SalaryMoney")} />
              </Line>
            )}
          </Card>
          {flexTotal}
          {limits}
          {balance}
          {this.state.employeeCustomCategories.length > 0 && draw(this.custom_category)}
          {this.data.dsPreviousEmployeeBenefits.Status == "CLOSED" && draw(this.carry_in_amounts)}
          {this.data.dsPreviousEmployeeBenefits.Status == "OPEN" && draw(this.previous_year_benefit_details)}
          {this.data.dsPreviousEmployeeBenefits.Status == "OPEN" && draw(this.previous_year_benefit_flex_total)}
          {this.data.dsPreviousEmployeeBenefits.Status == "OPEN" && draw(this.previous_year_benefit_amounts)}
          {(this.data.dsPreviousEmployeeBenefits.Status == "OPEN" && this.state.employeePrevCustomCategories != null && this.state.employeePrevCustomCategories.length > 0) && draw(this.previous_year_custom_category)}
          {flexSelection}
          {notificationDates}
          {isEligibleToResendWelcomeEmail && (
              <button
                onClick={this.resendEmployeeWelcomeEmail}
                className="RT-Button RT-Button--primary"
                style={resendWelcomeBtnStyle}
              >
                Resend Welcome Email
              </button>
          )}
        </>
      );
    }

    previous_year_benefit_flex_total({ field, draw, action }: RenderEvent) {
      let flexTotal = null;
      if(this.data.dsPreviousEmployeeBenefits.HasFlex === true)
      {
        flexTotal = (
          <Card background="previous-year-section">
            <Line>
              <Display field={field("@dsPreviousEmployeeBenefits.FlexBase")} />
              <Display field={field("@dsPreviousEmployeeBenefits.CreditCalcMethod")} />
            </Line>
          </Card>
        );
      }

      return (
        <>
          {flexTotal}
        </>
      );
    }

    carry_in_amounts({ field, draw, action }: RenderEvent) {
      return (
        <Card background="previous-year-section">
          <Line>
            <Display field={field("@dsEmployeeYear.HSACarriedIn")} />
            <Display field={field("@dsEmployeeYear.LSACarriedIn")} />
          </Line>
        </Card>
      );
    }

    previous_year_benefit_details({ field, draw, action }: RenderEvent) {
      let isPlanAdmin = false;
      if(this.data.dsPlanAdmins.UserId 
        && this.data.dsPreviousEmployeeBenefits.HSABase === 0 
        && this.data.dsPreviousEmployeeBenefits.LSABase === 0 
        && this.data.dsPreviousEmployeeBenefits.FlexBase === 0)
      {
        isPlanAdmin = true;
      }

      return (
        <Card label="Previous Year Category" background="previous-year-section">
          <Line>
            <Display field={field("@dsPreviousEmployeeBenefits.BenefitName")} />
          </Line>
          <Line>
            <Display field={field("@dsPreviousEmployeeBenefits.BenefitCategoryName")} />
            {isPlanAdmin ? <></> : <Display field={field("@dsPreviousEmployeeBenefits.Coverage")} />}
          </Line>
        </Card>
      );
    }

    previous_year_benefit_amounts({ field, draw, action }: RenderEvent) {
      let HSAAmounts = null;
      let LSAAmounts = null;
      let RSPAmounts = null;

      if(this.data.dsPreviousEmployeeBenefits.HasRSP === true)
      {
        RSPAmounts = (
          <Line>
              <Display field={field("@dsPreviousEmployeeBenefits.RSPChoiceAmount")} />
          </Line>
        )
      }

      if(this.data.dsPreviousEmployeeBenefits.HasHSA === true)
      {
        if(this.data.dsPolicyBenefit.CarryFwdHSA === "CCF")
        {
          HSAAmounts = (
            <Line>
                <Display field={field("@dsPreviousEmployeeBenefits.HSABalance")} />
                <Display field={field("@dsPreviousEmployeeBenefits.HSAMaxCarryFwd")} />
            </Line>
          )
        }
        else
        {
          HSAAmounts = (
            <Line>
                <Display field={field("@dsPreviousEmployeeBenefits.HSABalance")} />
            </Line>
          )
        }
        
      }

      if(this.data.dsPreviousEmployeeBenefits.HasLSA === true)
      {
        if(this.data.dsPolicyBenefit.CarryFwdLSA === "CCF")
        {
          LSAAmounts = (
            <Line>
                <Display field={field("@dsPreviousEmployeeBenefits.LSABalance")} />
                <Display field={field("@dsPreviousEmployeeBenefits.LSAMaxCarryFwd")} />
            </Line>
          )
        }
        else
        {
          LSAAmounts = (
            <Line>
                <Display field={field("@dsPreviousEmployeeBenefits.LSABalance")} />
            </Line>
          )
        }
      }
    
      if(this.data.dsPlanAdmins.UserId 
        && this.data.dsPreviousEmployeeBenefits.HSABase === 0 
        && this.data.dsPreviousEmployeeBenefits.LSABase === 0 
        && this.data.dsPreviousEmployeeBenefits.FlexBase === 0)
      {
        HSAAmounts = null;
        LSAAmounts = null;
        RSPAmounts = null;
      }

      return (
        <Card label="Previous Year Balances" background="previous-year-section">
            {HSAAmounts}
            {LSAAmounts}
            {RSPAmounts}
        </Card>
      );
    }
    
    resendFlexEmail = () => {
      const { dsEmployee } = this.data;
      const { dsEmployeeYear } = this.data;
      const { dsBenefitCategory } = this.data;
    
      axios
      .post(
        "/api/Employees/resendflexselectionemail", {
          benefitCategoryId: dsBenefitCategory.Id,
          policyId: dsBenefitCategory.Policy_Id,
          benefitYearId: dsEmployeeYear.BenefitYear_Id,
          flexSelectionDeadline: dsEmployeeYear.FlexSelectionDeadline,
          firstName: dsEmployee.FirstName,
          lastName: dsEmployee.LastName,
          email: dsEmployee.Email,
          employeeId: dsEmployee.Id,
          employeeYearId: dsEmployeeYear.Id,
          limit: dsEmployeeYear.FlexBase,
        }
      )
      .then((response) => {
        if (response.data.success) {
          toastr.success(response.data.message);
        } else {
          toastr.error("Failed to send email");
        }
      })
      .catch((error) => {
        toastr.error("Failed to send email");
      });
    }

    resendEmployeeWelcomeEmail = () => {
      const { dsEmployee, dsEmployeeYear, dsBenefitCategory, dsPolicyHolder } = this.data;
    
      axios
      .post(
        "/api/Employees/resendemployeewelcomeemail", {
          policyId: dsBenefitCategory.Policy_Id,
          benefitYearId: dsEmployeeYear.BenefitYear_Id,
          benefitCategoryId: dsBenefitCategory.Id,
          employeeId: dsEmployee.Id,
          firstName: dsEmployee.FirstName,
          lastName: dsEmployee.LastName,
          email: dsEmployee.Email,
          phName: dsPolicyHolder.Name,
          hsaBalance: dsEmployeeYear.HSABalance,
        }
      )
      .then((response) => {
        if (response.data.success) {
          toastr.success(response.data.message);
        } else {
          toastr.error("Failed to send email");
        }
      })
      .catch((error) => {
        toastr.error("Failed to send email");
      });
    }

    systemGeneratedBenefitStartDate() {
      var systemBenefitStartDate;
      if (this.data.dsEmployee.HireDate) {
        systemBenefitStartDate = this.data.dsEmployee.HireDate;
        if (this.data.dsEmployee.WaitingPeriodMonths) {
          systemBenefitStartDate = moment(this.data.dsEmployee.HireDate)
            .add(this.data.dsEmployee.WaitingPeriodMonths, "months")
            .format("YYYY-MM-DD");
        }
      }
      return systemBenefitStartDate;
    }

    general({ field, draw, action }: RenderEvent) {
      return (
        <Card
          label="General"
          actions={
            <>
              <Button action={action(this.edit)} label="Edit" style="link" />
            </>
          }
        >
          <Display field={field("Email")} />
          <Line>
            <Display field={field("MaidenName")} />
            <Display field={field("Nickname")} />
          </Line>
          <Line>
            <Display field={field("EmployeeNo")} />
            <Display field={field("DateOfBirth")} />
          </Line>
        </Card>
      );
    }

    termination_details({ field, draw, action }: RenderEvent) {
      return (
        <Card label="How do Terminations work?">
          <Line>
            <div>
              <b>Benefit End Date</b>: The last day you want the employee to have coverage. Only expenses incurred prior to this date will be processed.
            </div>
          </Line>
          <Line>
            <div>
              <b>Access</b>: How long the employee can access their account to
              log in, make claims, and see their claim history.
            </div>
          </Line>
          <Line>
            <div>
              <i>
                If you need to temporarily suspend an employee or their
                dependents' coverage, please enter an Inactive Date range under
                the “Date Ranges” tab instead.
              </i>
            </div>
          </Line>
        </Card>
      );
    }

    termination_status({ field, draw, action }: RenderEvent) {
      let terminationDeleteModal = null;
      if (this.state.showTerminationDeleteModal) {
        terminationDeleteModal = (
          <Modal
            className="react-modal react-modal-confirm"
            show={this.state.showTerminationDeleteModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header className="react-modal-title">
              <Modal.Title>Delete termination</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to delete this employee termination?
            </Modal.Body>
            <Modal.Footer>
              <ReactButton
                variant="light"
                onClick={() => this.closeTerminationDeleteModal()}
              >
                Cancel
              </ReactButton>
              <Button
                label="Delete"
                style="destructive"
                action={action(this.remove_termination)}
              ></Button>
            </Modal.Footer>
          </Modal>
        );
      }

      let reinstateModal = null;
      if (this.state.showReinstateModal) {
        reinstateModal = (
          <Modal
            className="react-modal react-modal-confirm"
            show={this.state.showReinstateModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header className="react-modal-title">
              <Modal.Title>Reinstate employee</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Card>
                <Line>
                  <div>
                    <label>Reinstate Note</label>
                    <input
                      className="RT-TextBox__input"
                      onChange={(e) => this.handleReinstateNoteChange(e)}
                      value={this.state.reinstateNote}
                    />
                  </div>
                </Line>
              </Card>
            </Modal.Body>
            <Modal.Footer>
              <ReactButton
                variant="light"
                onClick={() => this.closeReinstateModal()}
              >
                Cancel
              </ReactButton>
              <Button
                label="Reinstate"
                style="primary"
                action={action(this.reinstate_employee)}
              ></Button>
            </Modal.Footer>
          </Modal>
        );
      }

      let terminationLogTable = null;
      if (this.state.terminationLog[0].benefitEndDate != null) {
        terminationLogTable = (
          <div>
            <table className="table">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Date</th>
                  <th>Details</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.terminationLog.map((data, i) => {
                  let terminationNote = null;
                  if (data.terminationNote != null) {
                    terminationNote = <span>, {data.terminationNote}</span>;
                  }
                  let terminationDate = (
                    <ReactMoment format="YYYY-MM-DD">
                      {data.benefitEndDate}
                    </ReactMoment>
                  );
                  let terminationDescription = (
                    <span>
                      Benefit End Date (
                      <ReactMoment format="YYYY-MM-DD">
                        {data.benefitEndDate}
                      </ReactMoment>
                      ), 
                      {data.accessAfterTermination} Days Access{terminationNote}
                    </span>
                  );

                  let editTerminationButtons = null;
                  if (data.isActive) {
                    editTerminationButtons = (
                      <div>
                        <Button
                          label="Edit"
                          style="primary"
                          action={action(this.terminate)}
                        ></Button>{" "}
                        <span>or </span>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => this.showTerminationDeleteModal()}
                        >
                          Delete
                        </button>
                      </div>
                    );
                  } else {
                    editTerminationButtons = (
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => this.showReinstateModal()}
                      >
                        Reinstate
                      </button>
                    );
                  }

                  return (
                    <tr key={i}>
                      <td>Employee Terminated</td>
                      <td>{terminationDate}</td>
                      <td>{terminationDescription}</td>
                      <td>{editTerminationButtons}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      }

      let btnContainerStyle = this.state.terminationLog[0].benefitEndDate != null ? {display:"none"} : {display:"block"};
      return (
        <>
          {terminationDeleteModal}
          {reinstateModal}
          <Card
            label="Termination"
            actions={
              <div style={btnContainerStyle}>
                <Button
                  action={action(this.terminate)}
                  label="Terminate"
                  style="link"
                />
              </div>
            }
          >
            <Line>
              <CustomDisplayElement 
                label = "Access After Termination (days)"
                toolTip = {
                  <CustomToolTip
                    header="Access After Termination (days)"
                    bodyContent="How long the employee can access their account to log in, make claims, and see their claim history."
                  />
                }
                content = {this.data.dsEmployee.AccessAfterTerminationDays}
              />
              <Display
                field={field("BenefitEndDate")}
                toolTip={
                  <CustomToolTip
                    header="Benefit End Date"
                    bodyContent="The last day you want the employee to have coverage. Only expenses incurred prior to this date will be processed."
                  />
                }
              />
            </Line>
            <Line>
              <Display field={field("TerminationNote")} />
            </Line>
            <Line>{terminationLogTable}</Line>
          </Card>
        </>
      );
    }

    handleReinstateNoteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      this.setState({ reinstateNote: e.target.value });
    }

    showReinstateModal = () => {
      this.setState({ showReinstateModal: true });
    };
    
    closeReinstateModal=() => {
      this.setState({ showReinstateModal: false });
    }

    limit_adjustment_details({ field, draw, action }: RenderEvent) {
      return (
        <Card label="What is a Limit Adjustment?">
          <Line>
            <div>
              You can temporarily override an employee's benefit limit for their{" "}
              <b>current</b> benefit year to be higher or lower than the limit
              assigned to them by their benefit category. This limit adjustment
              will not carry-forward to the next benefit year after run-off
              ends. Limit adjustments can only be completed during the regular
              benefit year. They can’t be completed when a policy is in Run-Off.
            </div>
          </Line>
          <Line>
            <div>
              <i>
                Example: An employee is in a Manager benefit category and is
                assigned a limit of $1000. They made a $600 claim and now their
                available balance is $400. A limit adjustment of +$250 keeps
                them in the Manager benefit category of $1000, but temporarily
                for the current year changes their limit to $1250 and updates
                their balance to $650. If the account has Credit Carry Forward,
                the amount of credits carried forward to the next year remains
                up to a maximum of $1000.
              </i>
            </div>
          </Line>
        </Card>
      );
    }

    limit_adjustment_history({ field, draw, action }: RenderEvent) {
      return (
        <Card label="HSA Limit">
          <Line>
            <div>--</div>
          </Line>
        </Card>
      );
    }

    reporting({ field, draw, action }: RenderEvent) {
      return (
        <Card
          label="Reporting"
          actions={
            <>
              <Button action={action(this.edit)} label="Edit" style="link" />
            </>
          }
        >
          <Line>
            <Display field={field("@dsDivision.FullName")} />
            <Display field={field("@dsCostCentre.FullName")} />
          </Line>
        </Card>
      );
    }

    benefit_start({ field, draw, action }: RenderEvent) {
      return (
        <Card
          label="Benefits"
          actions={
            <>
              <Button
                action={action(this.edit_bencat)}
                label="Edit"
                style="link"
              />
            </>
          }
        >
          <Line>
            <Display
              field={field("@dsBenefitCategory.Name")}
              textStyle="bold"
            />
            <Display field={field("WaitingPeriodMonths")} />
            <Display field={field("BenefitStartDate")} />
          </Line>
        </Card>
      );
    }

    benefit_dates({ field, draw, action }: RenderEvent) {
      return (
        <Card
          label="Benefit Dates Set Up"
          actions={
            <>
              <Button
                action={action(this.edit_bencat)}
                label="Edit"
                style="link"
              />
            </>
          }
        >
          <Line>
            {/* <Display field={field("@dsBenefitCategory.Name")} textStyle="bold"/> */}
            <Display field={field("BenefitStartDate")} />
            <Display field={field("WaitingPeriodMonths")} />
            <Display field={field("@dsEmployeeYear.HasProrating")} />
          </Line>
        </Card>
      );
    }

    contact_info({ field, draw, action }: RenderEvent) {
      return (
        <Card
          label="Contact Information"
          actions={
            <>
              <Button
                action={action(this.edit_contact)}
                label="Edit"
                style="link"
              />
            </>
          }
        >
          <Display field={field("MailingStreet1")} />
          <Display field={field("MailingStreet2")} />
          <Line>
            <Display field={field("MailingCity")} />
            <Display field={field("MailingProv")} />
          </Line>
          <Line>
            <Display field={field("MailingCountry")} />
            <Display field={field("MailingPostalCode")} />
          </Line>
          <Line>
            <Display field={field("HomePhone")} />
            <Display field={field("MobilePhone")} />
          </Line>
        </Card>
      );
    }

    custom_category({ field, draw, action }: RenderEvent) {
      if(this.state.employeeCustomCategories == null)
        return;
      
      return (
        <Card
          label="Additional Account"
        >
          {this.state.employeeCustomCategories.map((category, index) => (
            <Line key={index}>
              <div className="RT-Static-Field">
                <div className='RT-Static-Field__label' style={{marginBottom:0}}>Category Name</div>
                <div className='RT-Static-Field__content'>{category.customCategoryName}</div>
              </div>
              <div className="RT-Static-Field">
                <div className='RT-Static-Field__label' style={{marginBottom:0}}>Category Type</div>
                <div className='RT-Static-Field__content'>{category.customCategoryType}</div>
              </div>
              {category.customCategoryProratedLimit == null ?
              (<div className="RT-Static-Field">
                <div className='RT-Static-Field__label' style={{marginBottom:0}}>Limit</div>
                <div className='RT-Static-Field__content'>${category.customCategoryLimit}</div>
              </div>) :
              (<div className="RT-Static-Field">
                <div className='RT-Static-Field__label' style={{marginBottom:0}}>Prorated Limit</div>
                <div className='RT-Static-Field__content'>${category.customCategoryProratedLimit}</div>
              </div>)}
              <div className="RT-Static-Field">
                <div className='RT-Static-Field__label' style={{marginBottom:0}}>Balance</div>
                <div className='RT-Static-Field__content'>${category.customCategoryBalance}</div>
              </div>
            </Line>
          ))}
        </Card>
      )
    }

    previous_year_custom_category({ field, draw, action }: RenderEvent) {
      if(this.state.employeePrevCustomCategories == null)
        return;
      
      return (
        <Card
          label="Previous Year Additional Account"
          background="previous-year-section"
        >
          {this.state.employeePrevCustomCategories.map((category, index) => (
            <Line key={index}>
              <div className="RT-Static-Field">
                <div className='RT-Static-Field__label' style={{marginBottom:0}}>Category Name</div>
                <div className='RT-Static-Field__content'>{category.customCategoryName}</div>
              </div>
              <div className="RT-Static-Field">
                <div className='RT-Static-Field__label' style={{marginBottom:0}}>Category Type</div>
                <div className='RT-Static-Field__content'>{category.customCategoryType}</div>
              </div>
              <div className="RT-Static-Field">
                <div className='RT-Static-Field__label' style={{marginBottom:0}}>Limit</div>
                <div className='RT-Static-Field__content'>${category.customCategoryLimit}</div>
              </div>
              <div className="RT-Static-Field">
                <div className='RT-Static-Field__label' style={{marginBottom:0}}>Balance</div>
                <div className='RT-Static-Field__content'>${category.customCategoryBalance}</div>
              </div>
            </Line>
          ))}
        </Card>
      )
    }
    
    async edit({ screen }: ActionEvent) {
      await screen.openDialog(
        <EditScreen employee_id={this.data.dsEmployee.Id} />,
        { onRecordChanged: this.refresh_data }
      );
    }

    async refresh_data({ screen }: ActionEvent) {
      await screen.restart();
    }

    async edit_contact({ screen }: ActionEvent) {
      await screen.openDialog(
        <Edit_addressScreen employee_id={this.data.dsEmployee.Id} />,
        { onRecordChanged: this.refresh_data }
      );
    }

    async edit_bencat({ screen }: ActionEvent) {
      await screen.openDialog(
        <Edit_bencatScreen employee_id={this.data.dsEmployee.Id} />,
        { onRecordChanged: this.refresh_data }
      );
    }

    async edit_benefitDates({ screen }: ActionEvent) {
      await screen.openDialog(
        <BenefitEditBenefitDatesScreen
          employeeBenefit_id={this.data.dsEmployeeYear.Id}
        />,
        { onRecordChanged: this.refresh_data }
      );

      await this.checkEmployeeDateRange();
    }

    async edit_benefits({ screen }: ActionEvent) {
      await screen.openDialog(
        <BenefitEditScreen
          employeeBenefit_id={this.data.dsEmployeeYear.Id}
        />,
        { onRecordChanged: this.refresh_data }
      );
    }

    async edit_flex_dates({ screen }: ActionEvent) {
      await screen.openDialog(
        <BenefitEditFlexDatesScreen
          employeeBenefit_id={this.data.dsEmployeeYear.Id}
        />,
        { onRecordChanged: this.refresh_data }
      );
    }

    async edit_startDate({ screen }: ActionEvent) {
      await screen.openDialog(
        <BenefitEditEmployeeStartDateScreen
          employeeBenefit_id={this.data.dsEmployeeYear.Id}
        />,
        { onRecordChanged: this.refresh_data }
      );

      await this.checkEmployeeDateRange();
    }

    renderStaticCheckmark() {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          style={{
            display: "block",
            width: 20,
            height: 20,
            fill: "var(--rt-primary-color)",
          }}
        >
          <path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z" />
        </svg>
      );
    }

    async edit_bendates({ screen }: ActionEvent) {
      await screen.openDialog(
        <Edit_bencatScreen employee_id={this.data.dsEmployee.Id} />,
        { onRecordChanged: this.refresh_data }
      );
    }

    async terminate({ screen }: ActionEvent) {
      await screen.openDialog(
        <TerminateScreen 
          employee_id={this.data.dsEmployee.Id} 
          access_days={this.state.terminationLog[0].accessAfterTermination}
        />,
        { onRecordChanged: this.refresh_data }
      );
      this.getTerminationLog();
      await screen.restart();
    }

    async remove_termination({ screen }: ActionEvent) {
      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          employeeId: this.data.dsEmployee.Id,
        }),
      };

      await fetch("/api/Terminate", requestOptions);
      this.closeTerminationDeleteModal();
      this.getTerminationLog();
      await screen.restart();
    }

    async reinstate_employee({ screen }: ActionEvent) {
      let now = new Date();
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          employeeId: this.data.dsEmployee.Id, 
          reinstateDate: now.toISOString(), 
          reinstateNote: this.state.reinstateNote
        }),
      };
      await fetch("/api/Employees/reinstateemployee", requestOptions);
      this.closeReinstateModal();
      this.getTerminationLog();
      await screen.restart();
    }

    checkFirstYearCoverage = () => {
      var self = this;
      axios
        .get(
          "/api/PlanAdmin/checkfirstyearcoverage?employeeId=" +
            this.data.dsEmployee.Id
        )
        .then((response) => {
          self.setState({
            enableBenefitEdit: response.data.enableEdit,
          });
        })
        .catch(function (error) {
          console.error(error);
        });
    };

    checkIsPolicyActive() {
      var self = this;
      axios
        .get(
          "/api/Employees/checkispolicyactive?policyId=" + this.data.dsBenefitCategory.Policy_Id
        )
        .then((response) => {
          self.setState({
            isPolicyActive: response.data.isActive,
          });
        })
        .catch(function (error) {
          console.error(error);
        });
    }

    checkIsAllowBenefitCategoryEdit = () => {
      var self = this;
      axios
        .get(
          "/api/PlanAdmin/isallowbenefitcategoryedit?policyId=" + this.data.dsBenefitCategory.Policy_Id,
        )
        .then((response) => {
          self.setState({
            isAllowBenefitCategoryEdit: response.data.isAllowBenefitCategoryEdit,
          });
        })
        .catch(function (error) {
          console.error(error);
        });
    }

    computeProratedMonths(StartDate: string, EndDate: string, BenefitEffectiveDate: string, HireDate: string, WaitingPeriodMonths: number ): any {
      let endDate = moment(EndDate, "YYYY-MM-DD");
      let startDate = moment(StartDate, "YYYY-MM-DD");
      let benefitEffectiveDate = moment(BenefitEffectiveDate, "YYYY-MM-DD");
      let hireDate = moment(HireDate, "YYYY-MM-DD");

      let benefitStartDate = this.computeBenefitStartDate(benefitEffectiveDate, hireDate, WaitingPeriodMonths);
      let policyYearEndMonth = this.computeSerialMonth(endDate.year(), endDate.month());
      let policyYearStartMonth;
      if(benefitStartDate.isBefore(benefitEffectiveDate) || benefitStartDate.isSame(benefitEffectiveDate))
      {
        policyYearStartMonth = this.computeSerialMonth(benefitEffectiveDate.year(), benefitEffectiveDate.month());
      } else {
        policyYearStartMonth = this.computeSerialMonth(benefitStartDate.year(), benefitStartDate.month());
      }
      let proratedMonths = policyYearEndMonth - policyYearStartMonth + 1;

      return proratedMonths;
    }

    computeBenefitStartDate(benefitEffectiveDate: any, hireDate: any, waitingPeriodMonths: number ): any {
      if (hireDate == null)
      {
          return benefitEffectiveDate;
      }
      var benefitStartDate = hireDate.add(waitingPeriodMonths, "months");
      if (benefitStartDate.isBefore(benefitEffectiveDate) || benefitStartDate.isSame(benefitEffectiveDate))
      {
          return benefitEffectiveDate;
      }
      return benefitStartDate;
    }

    computeSerialMonth(year: any, month: any): any {
      return year * 12 + month + 1;
    }

    checkEmployeeDateRange = async () => {
      var self = this;
      await axios
        .get(
          "/api/Employees/checkemployeedaterange?employeeId=" +
           this.props.employee_id
        )
        .then((response) => {
          self.setState({
            showDateRangeModal: response.data.showDateRangeModal,
          });
        })
        .catch(function (error) {
          console.error(error);
        });
    }

    checkEmployeeStartDate = async () => {
      var self = this;
      await axios
        .get(
          "/api/Employees/checkssstartdatevalid?employeeId=" +
           this.props.employee_id
        )
        .then((response) => {
          self.setState({
            isStartDateValid: response.data.isStartDateValid,
          });
        })
        .catch(function (error) {
          console.error(error);
        });
    }
  }
);
